import React, { useEffect, useState } from 'react'
//CSS
import styles from './Dashboard.module.css'
//Components
import LoadingPopup from '../../Components/Utils/LoadingPopup/LoadingPopup';

const Dashboard = () => {
  return (
    <div className={styles.container}>
        <div className={styles.sectionBox}>
          <div className={styles.sectionContent}>
            <div className={styles.sectionHeader}>

              <img src='/img/mesma-logo-2.png' alt="Mesma Logo" className={styles.mesmaLogo}/>
              <img src='/img/mesma-wave.png' alt="Mesma Wave" className={styles.widgetWide}/>

              <div className={styles.sectionContainer}>
                <div className={styles.column}>
                  <div className={styles.titleWrapper}>
                    <h2 className={styles.title}><u>Welcome, Introducing Mia</u><img src='/img/sparkle-multicoloured.svg' alt="Sparkle" className={styles.sparkleIcon}/></h2>
                  </div>
                  <h3>
                    Mesma's intelligent assistant — designed for leaders, quality
                    professionals and delivery teams in education, skills, and
                    employability.
                  </h3>
                </div>
                <div className={styles.column}>
                  <h3>It's not a chatbot.</h3>
                  <p>It's your sector-trained thought partner, built to help you:</p>
                  <br/>
                <ul>
                  <li>
                    <strong>Turn notes into clarity</strong> — capture discussions and
                    shape them into clear, confident summaries.
                  </li>
                  <li>
                    <strong>Spot strengths, gaps and risks</strong> — analyse diagnostic
                    inputs, challenge assumptions, and highlight opportunities for
                    improvement.
                  </li>
                  <li>
                    <strong>Focus on capacity to improve</strong> — move beyond
                    reporting today's performance to preparing for tomorrow's
                    challenges.
                  </li>
                </ul>
                </div>
              </div>
              <hr className={styles.horizontalRule}/>
              <div className={styles.sectionContainer}>
                <div className={styles.column}>
                  <div className={styles.titleWrapper}>
                    <h2 className={styles.title}><u>What's new?</u></h2>
                  </div>
                  <p><strong>Released August 2026</strong></p>
                  <p>We've introduced the first phase of Mia's evidence-based support capabilities, helping users work more efficiently with documents, diagnostics, and AI-powered guidance across the platform.</p>
                  <ul>
                    <li><strong>AI-Powered Evidence Extraction</strong> — Mia can now extract and process information from uploaded evidence files to support the diagnostic page.
                      <ul>
                        <li>Upload evidence files directly or select them from your Library for AI-assisted analysis.</li>
                        <li>Mia can extract content from supported file formats and convert evidence into structured information ready for use in diagnostics.</li>
                        <li>Clear links to source evidence help users validate and review AI-generated outputs.</li>
                        <li>Compare Mia's response with a previous one.</li>
                      </ul>
                    </li>
                    <li><strong>Mia Coach</strong> — real-time support while completing diagnostic questions.
                      <ul>
                        <li>Ask Mia for contextual guidance directly within diagnostic question pages.</li>
                        <li>Receive coaching and suggestions to help identify gaps and strengthen responses.</li>
                        <li>Guidance is delivered alongside your diagnostic, supporting reflection without interrupting workflow.</li>
                        <li>Users remain in control and can decide how to apply Mia's recommendations.</li>
                      </ul>
                    </li>
                    <li><strong>Enhanced Analyse Chat</strong> — Analyse now supports conversational exploration of evidence files.
                      <ul>
                        <li>Attach Library files directly to Analyse conversations.</li>
                        <li>Upload evidence files into chat for immediate analysis.</li>
                        <li>Ask questions about uploaded evidence and receive contextual responses.</li>
                        <li>Analyse multiple files together to identify themes, risks, trends, and areas for improvement.</li>
                      </ul>
                    </li>
                  </ul>
                  <br/>
                  <p><strong>Released April 2026</strong></p>
                  <p>We've continued evolving the Develop experience to make workflows simpler, more intuitive, and better aligned with how organisations are using the platform today.</p>
                  <ul>
                    <li><strong>Mia-Powered Develop</strong> — Develop is now powered by Mia, bringing smarter guidance and a more connected experience across the platform.</li>
                    <li><strong>Improved User Management</strong> — the View by User page has been replaced with improved filtering options, allowing you to filter activity directly by user. Department assignment during imports is now managed differently.</li>
                    <li><strong>Simpler and More Trusted Workflows</strong> — the Publish/Unpublish feature has been removed to reduce uncertainty around what users can and cannot see, and the Planned Activity page is no longer included in Develop since most organisations import activities rather than schedule them.</li>
                    <li><strong>More Connected Tools</strong> — Develop has now been included in Analyse, alongside Track and Evaluate, creating a more unified experience across the platform.</li>
                    <li><strong>More Flexible Diagnostics and Templates</strong> — pre-activity notes can now be added as a question within the diagnostic or within the main section of the criteria template. Reflection comment boxes are now mandatory, preventing the missing-field issues that caused imported templates to be archived in Gen2.</li>
                    <li><strong>New Permissions for Diagnostic Questions</strong> — QA users can now control who can view their notes and comments through a new privacy setting on the diagnostic question page. Available in both Develop and Evaluate, supporting more secure and flexible quality review workflows.</li>
                  </ul>
                  <br/>
                  <p><strong>Released Feb 2026</strong></p>
                  <p>Improvement Plans integrated into Track — Analyse is now built directly into Track (formerly known as Improve), creating a more connected workflow:</p>
                  <ul>
                    <li>Smoother progression from reflection to planning.</li>
                    <li>Clearer pathways from insight to action.</li>
                  </ul>
                  <br/>
                  <p><strong>Released Jan 2026</strong></p>
                  <ul>
                    <li><strong>Enquire and Evaluate combined</strong> — build and customise your own templates, analyse multiple diagnostics more efficiently, and enjoy faster workflows within a unified experience.</li>
                    <li><strong>Enhanced Analyse prompts</strong> — more targeted reflective questions, better guidance for interpreting results, and AI-driven prompts to support decision-making.</li>
                  </ul>
                  <br/>
                  <p><strong>Released Sept 2025</strong></p>
                  <p>We've redesigned the layout to make your experience simpler and more intuitive:</p>
                  <ul>
                    <li>Easier navigation with step-by-step screens.</li>
                    <li>Auto-saving text boxes so your work is always captured.</li>
                    <li>Freedom to choose your workspace: use the new Mia page or the original Evaluate page — your data stays in sync.</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default Dashboard
